import Details from './Details';
import Rates from './Rates';
import Locations from './Locations';
import Departments from './Departments';
import Contacts from './Contacts';
import Payment from './Payment';
import Workers from './Workers';

export { Details, Rates, Locations, Departments, Contacts, Payment, Workers };



// WEBPACK FOOTER //
// ./src/components/app/companyDetails/Tabs/index.js